import { Link } from 'react-router-dom';
import { Wrench, LogIn } from 'lucide-react';
import { SiteLogo } from '../../components/ui/SiteLogo';
import { AuroraBackground } from '../../components/ui/AuroraBackground';
import './MaintenancePage.css';

const TICKER_ITEMS = Array(6).fill('Site en maintenance');

/**
 * Affichée à la place du site public lorsque le mode maintenance est activé
 * (Paramètres > Général). Un membre du back-office peut toujours se connecter
 * via le lien ci-dessous : une fois authentifié, le site normal redevient visible.
 */
export function MaintenancePage({ message }) {
  return (
    <div className="maintenance-page">
      <AuroraBackground tone="dark" />

      <div className="maintenance-page__ticker" aria-hidden="true">
        <div className="maintenance-page__ticker-track">
          {[...TICKER_ITEMS, ...TICKER_ITEMS].map((texte, i) => (
            <span key={i}>{texte}</span>
          ))}
        </div>
      </div>

      <div className="maintenance-page__content">
        <div className="maintenance-page__card">
          <div className="maintenance-page__logo">
            <SiteLogo tone="sombre" height={40} />
          </div>

          <div className="maintenance-page__icon">
            <span className="maintenance-page__icon-ring" />
            <Wrench size={26} strokeWidth={1.8} />
          </div>

          <h1>Site en maintenance</h1>
          <p>
            {message ||
              "Nous améliorons actuellement notre site pour mieux vous servir. Merci de votre patience, nous serons de retour très prochainement."}
          </p>

          <Link to="/admin/connexion" className="maintenance-page__admin-link">
            <LogIn size={15} /> Connexion administrateur
          </Link>
        </div>
      </div>
    </div>
  );
}
